module.exports = __webpack_public_path__ + "img/banner1.9cfc9463.png";